<template>
  <div class="row c-mt-5 c-items-center">
    <div class="col-12">
      <p class="c-mb-3 font-medium">
        {{ t('customer_centre') }}
      </p>
    </div>
    <div class="col-3 c-sm:col-2 c-lg:col-1">
      <ResponsiveImage
        src="default-review-image.png"
        alt="customer centre"
        img-class="footer__person image-cover c-rounded-circle"
        sizes="10vw"
      />
    </div>
    <div class="col-7 c-pl-4">
      <a
        :href="`mailto:${t('info_email') + useMailSuffix()}`"
        class="flex c-items-center c-py-1 !no-underline text-primary whitespace-nowrap"
      >
        <i class="mi-envelope icon-20 c-mr-2" />
        {{ t('info_email') + useMailSuffix() }}
      </a>
      <a
        :href="`tel:${t('support_phone_link')}`"
        class="flex c-items-center c-py-1 !no-underline text-primary whitespace-nowrap"
      >
        <i class="mi-phone icon-20 c-mr-2" />
        {{ t('support_phone') }}
      </a>
      <a
        v-if="locale === 'cs' || locale === 'sk'"
        :href="t('whatsapp_link')"
        target="_blank"
        class="flex c-items-center c-py-1 !no-underline text-primary whitespace-nowrap"
      >
        <i class="mi-whatsapp icon-20 c-mr-2" />
        {{ t('whatsapp') }}
      </a>
    </div>
    <div class="col-12 c-pt-3">
      <p class="c-m-0 small opacity-50">
        {{ t('working_hours_mo_th') }}<br>
        {{ t('working_hours_fr') }}
      </p>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

import ResponsiveImage from '@/components/general/BaseImage.vue'
import { useMailSuffix } from "@/mixins/useMailSuffix";

const { t, locale } = useI18n()
</script>

<i18n>
  {
    "cs": {
    "customer_centre": "Zákaznické centrum",
    "info_email": "info",
    "support_phone": "+420 210 012 140",
    "support_phone_link": "+420210012140",
    "whatsapp": "WhatsApp",
    "whatsapp_link": "https://wa.me/420725366466",
    "working_hours_fr": "V pátek 8.00–16.00.",
    "working_hours_mo_th": "Od pondělí do čtvrtka 8.00–16.30."
},
    "sk": {
    "customer_centre": "Zákaznícke centrum",
    "info_email": "info",
    "support_phone": "+421 221 025 208",
    "support_phone_link": "+421221025208",
    "whatsapp": "WhatsApp",
    "whatsapp_link": "https://wa.me/420725366466",
    "working_hours_fr": "V piatok 8.00 - 16.00.",
    "working_hours_mo_th": "Od pondelka do štvrtka 8.00 - 16.30"
},
    "pl": {
    "customer_centre": "Biuro obsługi klienta",
    "info_email": "biuro",
    "support_phone": "(+48) 22 300 17 88",
    "support_phone_link": "(+48)223001788",
    "whatsapp": "WhatsApp",
    "whatsapp_link": "https://wa.me/420725366466",
    "working_hours_fr": "Od poniedziałku do piątku 8:00-16:00",
    "working_hours_mo_th": "Od poniedziałku do piątku 8:00-16:00"
},
    "hu": {
    "customer_centre": "Ügyfélszolgálat",
    "info_email": "info",
    "support_phone": "+36 1 550 7665",
    "support_phone_link": "+3615507665",
    "whatsapp": "WhatsApp",
    "whatsapp_link": "https://wa.me/420725366466",
    "working_hours_fr": "Pénteken 8:00 - 16:00",
    "working_hours_mo_th": "Hétfőtől - csütörtökig 8:00 - 16:30"
},
    "de": {
    "customer_centre": "Kundenservice",
    "info_email": "Info",
    "support_phone": "+49 221 8461 5111",
    "support_phone_link": "+49 221 8461 5111",
    "whatsapp": "WhatsApp",
    "whatsapp_link": "https://wa.me/420725366466",
    "working_hours_fr": "",
    "working_hours_mo_th": "Montag bis Freitag 7.00 bis 15.00 Uhr."
},
    "at": {
    "customer_centre": "Kundenservice",
    "info_email": "Info",
    "support_phone": "+49 221 8461 5111",
    "support_phone_link": "+49 221 8461 5111",
    "whatsapp": "WhatsApp",
    "whatsapp_link": "https://wa.me/420725366466",
    "working_hours_fr": "",
    "working_hours_mo_th": "Montag bis Freitag 7.00 bis 15.00 Uhr."
},
    "ro": {
    "customer_centre": "Serviciul clienți",
    "info_email": "info",
    "support_phone": "+40 373 761 377",
    "support_phone_link": "+40373761377",
    "whatsapp": "",
    "whatsapp_link": "",
    "working_hours_fr": "",
    "working_hours_mo_th": "Luni - vineri 9:30-15.00"
},
    "fr": {
    "customer_centre": "Service client",
    "info_email": "info",
    "support_phone": " 01 89 70 71 57",
    "support_phone_link": " 01 89 70 71 57",
    "whatsapp": "WhatsApp",
    "whatsapp_link": "https://wa.me/420725366466",
    "working_hours_fr": "Vendredi de 8 h à 16 h",
    "working_hours_mo_th": "Du lundi au jeudi de 8h00 à 16h30."
},
    "it": {
    "customer_centre": "Centro assistenza clienti",
    "info_email": "info",
    "support_phone": "",
    "support_phone_link": "",
    "whatsapp": "WhatsApp",
    "whatsapp_link": "https://wa.me/420725366466",
    "working_hours_fr": "Venerdì dalle 8.00 alle 16.00.",
    "working_hours_mo_th": "Dal lunedì al giovedì dalle 8.00 alle 16.30."
}
  }
</i18n>
